type GetProductNameShort = () => string;
export const getProductNameShort: GetProductNameShort = () => 'Engage';
